import { useState } from "react";
import { Plus, Check } from "lucide-react";
import { COPING_OPTIONS } from "../lib/config";
import { usePrefs, useSavePrefs } from "../lib/store";

export function CopingSelector({ value, onChange }) {
  const { data: prefs } = usePrefs();
  const save = useSavePrefs();
  const [custom, setCustom] = useState("");
  const own = prefs?.copingTools ?? [];
  const all = [...COPING_OPTIONS, ...own.filter((o) => !COPING_OPTIONS.includes(o)), ...value.filter((v) => !COPING_OPTIONS.includes(v) && !own.includes(v))];
  const toggle = (o) => onChange(value.includes(o) ? value.filter((v) => v !== o) : [...value, o]);
  const add = () => {
    const t = custom.trim();
    if (!t) return;
    if (!own.includes(t)) save.mutate({ copingTools: [...own, t] });
    if (!value.includes(t)) onChange([...value, t]);
    setCustom("");
  };
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-wrap gap-2.5">
        {all.map((o, i) => {
          const on = value.includes(o);
          return (
            <button key={o} type="button" onClick={() => toggle(o)} data-testid={`coping-${i}`}
              className={`inline-flex items-center gap-1.5 rounded-full px-4 h-10 text-sm font-medium border transition-colors ${on ? "bg-t-brand text-t-onbrand border-transparent" : "bg-t-surface2 text-t-on2 border-t-border hover:border-t-brand"}`}>
              {on ? <Check size={14} strokeWidth={3} /> : null}{o}
            </button>
          );
        })}
      </div>
      <div className="flex gap-2">
        <input className="tf-input" value={custom} onChange={(e) => setCustom(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()}
          placeholder="Add your own (saved for next time)…" data-testid="coping-custom-input" />
        <button type="button" onClick={add} data-testid="coping-custom-add" className="shrink-0 w-12 rounded-2xl bg-t-brand2 text-t-brand grid place-items-center"><Plus size={20} /></button>
      </div>
    </div>
  );
}
